@import '../../assets/styles/theme.scss';

body {
  background: white;
}

.container {
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  font-family: 'Lato';
  background: white;
}
.logoImage {
  height: 180px;
  width: 400px;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(../../assets/images/alice-logo.png);
  background-size: cover;
}
.loginInfo {
  color: $meta;
  font-size: 18px;
  text-align: center;
  margin-bottom: 10px;
}
.loginForm {
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3em;
  color: black;
  width: 450px;
  margin-bottom: 5%;
  h1 {
    font-size: 2.5em;
    margin-bottom: 0.3em;
    padding: 12px 0;
  }
  .formField {
    position: relative;
    font-size: 20px;
    border-bottom: 1px solid #e74c3c;
    margin: 20px 0 8px 0;
    transition: 0.3s;
    width: 90%;

    input {
      border: none;
      outline: none;
      background: transparent;
      color: black;
      padding-left: 10px;
    }
  }
}

.resetInput {
  width: 65%;
}
.signupInput {
  width: 65%;
  margin-bottom: 12px;
}

.leftColumn {
  height: 100%;
  background-image: url(../../assets/images/socks.jpg);
  background-position: 80%;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  flex: 2;
}
